import { useState, createRef, useEffect, useCallback } from "react";
import {
  FormFlex,
  FormFlexDiv,
  TabContentWrapper,
  InlineFormDiv,
  AccountSummaryWrapper,
} from "../../pages/Dashboard/styles/dashboard.style";
import DatePickerComponent from "../datepicker/DatePicker";
import colors from "../../assets/colors.json";
import { InputWrapper, AuthButton } from "../../pages/auth/Login.style";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import { toast } from "react-toastify";
import {
  createCertifications,
  deleteCertifications,
  getCertifications,
} from "../../services/user";
import FormLoader from "../FormLoader";
import { useSelector } from "react-redux";

const Certifications = ({ status }) => {
  console.log(status)
  const onPickFileRef = createRef();
  const { admToken, user } = useSelector((state) => state.auth);

  const [fileName, setFileName] = useState("");
  const [loadingCertification, setLoadingCertification] = useState(false);
  const [loadingSaving, setLoadingSaving] = useState(false);
  const [loadingDeleting, setLoadingDeleting] = useState(null);
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState([]);

  const [form, setForm] = useState({
    institution: "",
    courseName: "",
    licenseName: "",
    issueingBody: "",
    startDate: null,
    endDate: null,
    proofFileBase64: "",
    id: 0,
  });

  const isTab = useMediaQuery({ maxWidth: 992 });

  const pickFile = () => {
    onPickFileRef.current.click();
  };

  const onPickFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = () => {
      setForm((prev) => ({
        ...prev,
        proofFileBase64: reader.result,
      }));
    };

    reader.readAsDataURL(file);
  };

  const getCert = useCallback(async () => {
    try {
      setLoadingCertification(true);
      const res = await getCertifications(admToken, user?.staffId);

      if (res.status && res.statusCode === 2) {
        setData(res.data);
      } else {
        setData([]);
      }
    } finally {
      setLoadingCertification(false);
    }
  }, [admToken, user?.staffId]);

  useEffect(() => {
    getCert();
  }, [user?.staffId]);

  const handleSave = async () => {
    const payload = {
      ...form,
      id: form.id || 0,
    };

    try {
      setLoadingSaving(true);
      const res = await createCertifications(admToken, payload, user?.staffId);

      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        setForm({
          institution: "",
          courseName: "",
          licenseName: "",
          issueingBody: "",
          startDate: null,
          endDate: null,
          proofFileBase64: "",
          id: 0,
        });
        setFileName("");
        getCert();
      } else {
        toast.error(res.message);
      }
    } finally {
      setLoadingSaving(false);
    }
  };

  const handleEdit = (item) => {
    setForm({
      institution: item.institution,
      courseName: item.courseName,
      licenseName: item.licenseName,
      issueingBody: item.issueingBody,
      startDate: item.startDate,
      endDate: item.endDate,
      proofFileBase64: item.proofFileBase64 || "",
      id: item.id,
    });

    setFileName(item.fileName || "Uploaded File");
    setEdit(true)
  };

  const handleDelete = async (id) => {
    try {
      setLoadingDeleting(id);
      const res = await deleteCertifications(admToken, id);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        getCert();
      } else {
        toast.error(res.message);
      }
    } finally {
      setLoadingDeleting(null);
    }
  };

  return (
    <TabContentWrapper>
      <FormFlex>
        <FormFlexDiv>
          <InputWrapper>
            <label>Institution/Body</label>
            <input
              type="text"
              value={form.institution}
              onChange={(e) =>
                setForm({ ...form, institution: e.target.value })
              }
              disabled={!(status === 0 || status === 4)}
            />
          </InputWrapper>

          <InputWrapper>
            <label>License Name</label>
            <input
              type="text"
              value={form.licenseName}
              onChange={(e) =>
                setForm({ ...form, licenseName: e.target.value })
              }
              disabled={!(status === 0 || status === 4)}
            />
          </InputWrapper>
        </FormFlexDiv>

        <FormFlexDiv>
          <InputWrapper>
            <label>Course Name</label>
            <input
              type="text"
              value={form.courseName}
              onChange={(e) =>
                setForm({ ...form, courseName: e.target.value })
              }
              disabled={!(status === 0 || status === 4)}
            />
          </InputWrapper>

          <InputWrapper>
            <label>Issuing Body</label>
            <input
              type="text"
              value={form.issueingBody}
              onChange={(e) =>
                setForm({ ...form, issueingBody: e.target.value })
              }
              disabled={!(status === 0 || status === 4)}
            />
          </InputWrapper>
        </FormFlexDiv>
      </FormFlex>

      <FormFlex>
        <FormFlexDiv>
          <InputWrapper>
            <label>Start Date</label>
            <DatePickerComponent
              selected={form.startDate ? new Date(form.startDate) : null}
              setSelected={(val) =>
                setForm({
                  ...form,
                  startDate: val ? val.toISOString() : null,
                })
              }
              disabled={!(status === 0 || status === 4)}
            />
          </InputWrapper>
        </FormFlexDiv>

        <FormFlexDiv>
          <InputWrapper>
            <label>End Date</label>
            <DatePickerComponent
              selected={form.endDate ? new Date(form.endDate) : null}
              setSelected={(val) =>
                setForm({
                  ...form,
                  endDate: val ? val.toISOString() : null,
                })
              }
              disabled={!(status === 0 || status === 4)}
            />
          </InputWrapper>
        </FormFlexDiv>
      </FormFlex>

      <FormFlex>
        <input
          type="file"
          hidden
          onChange={onPickFile}
          ref={onPickFileRef}
        />
        <FormFlexDiv>
          <InlineFormDiv width="100%">
            <div style={{ width: isTab ? "100%" : "70%" }}>
              <InputWrapper>
                <label>Proof of Qualification</label>
                <input
                  type="text"
                  value={fileName}
                  placeholder="File Name"
                  readOnly
                />
              </InputWrapper>
            </div>

            <AuthButton
              width={isTab ? "100%" : "20%"}
              onClick={pickFile}
              bg={colors.secondary}
              color={colors.primary}
              disabled={!(status === 0 || status === 4)}
            >
              Upload File
            </AuthButton>
          </InlineFormDiv>
        </FormFlexDiv>
      </FormFlex>
      {status === 4 || status === 0 && (
        <div className="flex justify-end my-7">
          <button
            disabled={loadingSaving}
            onClick={handleSave}
            className="px-8 py-2.5 rounded-lg text-white bg-primary disabled:bg-gray-300"
          >
            {loadingSaving
              ? edit
                ? "Updating..."
                : "Adding..."
              : edit
                ? "Update"
                : "Add"}
          </button>
        </div>
      )}

      <AccountSummaryWrapper>
        <table>
          <tr className="table-head" style={{ color: "black" }}>
            <th>Institution</th>
            <th>Course</th>
            <th>period</th>
            <th></th>
          </tr>
          {loadingCertification ? (
            <tr>
              <td colSpan={5}>
                <FormLoader />
              </td>
            </tr>
          ) : data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index} style={{ fontWeight: "bold" }}>
                <td>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        height: 5,
                        width: 5,
                        padding: 5,
                        borderRadius: "50%",
                        marginRight: 8,
                        backgroundColor: colors.primary,
                      }}
                    ></div>
                    <div>
                      <p>{item.issueingBody}</p>
                      <p>{item.institution}</p>
                    </div>
                  </div>
                </td>

                <td>{item.courseName}</td>

                <td>
                  {moment(item.startDate).format("YYYY")} -
                  {moment(item.endDate).format("YYYY")}
                </td>

                <td>
                  <div className="flex gap-8">
                    {/* EDIT */}
                    <button
                      disabled={!(status === 0 || status === 4) || loadingSaving || loadingCertification}
                      onClick={() => handleEdit(item)}
                      style={{
                        borderWidth: 1,
                        borderRadius: 5,
                        borderColor: colors.primary,
                        padding: "10px 20px",
                        background: "transparent",
                        fontWeight: "bold",
                      }}
                    >
                      Edit
                    </button>

                    {/* DELETE */}
                    <button
                      onClick={() => handleDelete(item.id)}
                      style={{
                        borderWidth: 1,
                        borderRadius: 5,
                        borderColor: colors.primary,
                        padding: "10px 20px",
                        background: "transparent",
                        fontWeight: "bold",
                      }}
                      disabled={!(status === 0 || status === 4) || loadingDeleting || loadingCertification}
                    >
                      {loadingDeleting ? "Deleting..." : "Delete"}
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td>No Certification</td>
            </tr>
          )}
        </table>
      </AccountSummaryWrapper>
    </TabContentWrapper>
  );
};

export default Certifications;
